export default __webpack_public_path__ + "static/media/VBChainNFTLogo.ee8d615a.png";